import cn from 'classnames';
import React from 'react';

import ArrowLeft from '@sats-group/icons/18/arrow-left';
import LinkButton from '@sats-group/ui-lib/react/link-button/link-button';
import Progressbar from '@sats-group/ui-lib/react/progress-bar/progress-bar';

import type { LayoutHeader as Props } from './layout-header.props';

import ContentContainer from '$/shared/components/content-container/content-container';
import Logo from '$/shared/components/logo/logo';

const LayoutHeader: React.FunctionComponent<Props> = ({
  back,
  logo,
  progress,
}) => {
  return (
    <header
      className={cn('layout-header', {
        'layout-header--with-progress-bar': !!progress,
      })}
    >
      <div className="layout-header__content-outer">
        <ContentContainer
          className="layout-header__content-inner"
          theme={ContentContainer.themes.wide}
        >
          {/* container is kept outside the conditional to maintain a fixed height and prevent header from shifting based on back button's presence. */}
          <div className="layout-header__back-button-container">
            {back ? (
              <LinkButton
                iconOnly
                leadingIcon={<ArrowLeft />}
                size={LinkButton.sizes.small}
                variant={LinkButton.variants.secondary}
                {...back}
              />
            ) : null}
          </div>
          <Logo variant={Logo.variants.letter} {...logo} />
        </ContentContainer>
      </div>
      {progress ? <Progressbar {...progress} /> : null}
    </header>
  );
};

export default LayoutHeader;
